import React from 'react';
import {
  ResponsiveContainer, PieChart, Pie, Cell, Tooltip, Legend,
} from 'recharts';

const money = (v) => Number(v || 0).toLocaleString('es-PE', { style: 'currency', currency: 'PEN' });
const COLORS = ['#dc2626','#f59e0b','#374151','#ef4444','#fbbf24','#6b7280','#b91c1c','#d1d5db','#f59e0b','#9ca3af'];

function ChartTooltip({ active, payload }) {
  if (!active || !payload?.length) return null;
  const item = payload[0];

  return (
    <div className="rounded-2xl border border-gray-100 bg-white px-3 py-2 text-xs shadow-lg">
      <div className="text-gray-500">{item?.name}</div>
      <div className="mt-1 flex items-center gap-2 text-sm font-semibold text-gray-900">
        <span className="inline-block h-2 w-2 rounded-full bg-red-500" />
        {money(item?.value ?? 0)}
      </div>
    </div>
  );
}

export default function AdvisorPieChart({ data = [], title = 'Desembolso por asesor' }) {
  return (
    <div className="h-full">
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h3 className="text-base font-semibold text-gray-900">{title}</h3>
          <p className="text-xs text-gray-500">Total desembolsado</p>
        </div>
      </div>

      <div className="h-[320px] overflow-visible">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart margin={{ top: 8, right: 16, left: 16, bottom: 8 }}>
            <Pie
              data={data}
              dataKey="value"
              nameKey="name"
              outerRadius={110}
              innerRadius={60}
              paddingAngle={3}
              labelLine={false}
            >
              {data.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
            </Pie>
            <Tooltip content={<ChartTooltip />} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
